module.exports = __webpack_public_path__ + "img/1.8bda9f79.jpg";